import { DEFAULT_FAVICON } from "../../utils/constants";

export const helmetLinks = (link) => [
  {
    rel: "icon",
    type: "image/png",
    href: link || DEFAULT_FAVICON,
  },
  {
    rel: "icon",
    type: "image/png",
    href: link || DEFAULT_FAVICON,
  },
  {
    rel: "apple-touch-icon",
    type: "image/png",
    href: link || DEFAULT_FAVICON,
  },
  {
    rel: "shortcut icon",
    type: "image/png",
    href: link || DEFAULT_FAVICON,
  },
  {
    rel: "apple-touch-icon",
    type: "image/jpg",
    href: link || DEFAULT_FAVICON,
  },
  {
    rel: "shortcut icon",
    type: "image/jpg",
    href: link || DEFAULT_FAVICON,
  },
];
